import { createApp } from 'vue'
import tableResponsive from './table-responsive.vue';

export default () => {
  document.querySelectorAll('table-responsive').forEach((el) => {
    const propData = el.closest('section').nextElementSibling.innerHTML;
    createApp(tableResponsive, {data:propData}).mount(el);
  })
}